/**
 * Mağaza kuralı — iOS'ta premium görünmez.
 *
 * 15 Eylül 2026: Apple 2.9.3 (56)'yı Guideline 2.1(b) ile reddetti — uygulamada
 * "premium abonelik" geçiyordu ama App Store Connect'te In-App Purchase ürünü
 * yoktu ve abonelik düğmeleri çalışmıyordu. StoreKit kurulana kadar iOS paket
 * uygulamasında premium'a dair hiçbir ekran, düğme, rozet ya da metin
 * gösterilmez. Web ve Android bu karardan etkilenmez.
 */
export function premiumGizli() {
  try {
    const cap = typeof window !== "undefined" ? window.Capacitor : null;
    return !!(
      cap &&
      typeof cap.getPlatform === "function" &&
      cap.getPlatform() === "ios"
    );
  } catch {
    return false;
  }
}
